import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import VerticalCard from "../ArticleCard/VerticalCard";
import SectionContainer from "../SectionContainer";

/**
 * Article Top Articles 最多点击, datasource is same as the one in Home Page
 */
export default function ArticleTopArticles() {
  const { topArticles = [] } = useRouteResponse("articlePage");
  return topArticles.length === 0 ? null : (
    <SectionContainer title="最多点击">
      <div className="mb-4 lg:grid lg:grid-cols-12">
        {[...topArticles].map((article) => {
          return (
            <VerticalCard
              key={article.id}
              article={{
                ...article,
                urlPath: `${article.urlPath}?ref=article-bottom-most-clicked`,
              }}
              className="col-span-12 lg:col-span-3"
            />
          );
        })}
      </div>
    </SectionContainer>
  );
}
